import type { VoidFunctionComponent } from 'react';

import Icon from '../../../generic/Icon/Icon';
import { icons } from '../../../generic/Icon/icons';
import RouterLink from '../../../generic/Link/RouterLink';
import PageHeadingBreadcrumbs from '../../../generic/PageHeadingBreadcrumbs';
import type { VcsApp } from '../../../../../shared/vcs/githubApp/apps';

import styles from './VcsImportHeader.module.less';

/** Where Back returns to: the quick import service picker. */
const QUICK_IMPORT_URL = '/projects/import/cloud';

/** The crumb naming where the user has landed, per the active account's app. */
const APP_CRUMB: Record<VcsApp, string> = {
  fossabot: 'fossabot app',
  fossaCore: 'FOSSA GitHub app',
};

type Props = {
  app: VcsApp;
};

/**
 * The page's own header, standing in for the legacy import Subnav: a Back link out to the
 * service picker, then the breadcrumb naming where the user has landed.
 */
export const VcsImportHeader: VoidFunctionComponent<Props> = ({ app }) => (
  <header className={styles.header}>
    <div className="container container-responsive">
      <RouterLink to={QUICK_IMPORT_URL} className={styles.back}>
        <span className={styles.backIcon}><Icon icon={icons.angleLeft} /></span>
        Back
      </RouterLink>
      <div className={styles.crumbs}>
        <PageHeadingBreadcrumbs
          crumbs={[{ content: 'Quick import' }, { content: APP_CRUMB[app] }]}
          separator={<Icon icon={icons.angleRight} />}
        />
      </div>
    </div>
  </header>
);
